export const reportBodyTemplate = [
  {
    sectionLabel: "General Information",
    fields: [
      {
        fieldNames: "*",
        sourceTab: "Details",
        excludedFields: ["Injuries__c"],
      },
      {
        fieldNames: [
          "Nurse_at_Time_of_Incident__c",
          "CNA_at_Time_of_Incident__c",
          "Caregiver_at_Time_of_Incident__c",
        ],
        sourceTab: "Patient Demographics",
      },
    ],
  },
  {
    sectionLabel: "Vital Signs",
    fields: [
      {
        fieldNames: "*",
        sourceTab: "Patient Demographics",
        sourceSection: "Vital Signs",
      },
    ],
  },
  {
    sectionLabel: "Injuries",
    fields: [{ fieldNames: ["Injuries__c"], sourceTab: "Details" }],
  },
  {
    sectionLabel: "Notifications",
    fields: [
      {
        fieldNames: "*",
        sourceTab: "Patient Demographics",
        sourceSection: "Notifications",
      },
      {
        fieldNames: "*",
        sourceTab: "Details",
        sourceSection: "Immediate Response",
      },
    ],
  },
  {
    sectionLabel: "Statements",
    fields: [
      {
        fieldNames: "*",
        excludedFields: ["Interviews__c"],
        sourceTab: "Statements",
        sourceSection: "Statements",
        subSection: "Statements",
      },
      {
        fieldNames: ["Interviews__c"],
        sourceTab: "Statements",
        sourceSection: "Statements",
        subSection: "Interviews",
      },
    ],
  },
  {
    sectionLabel: "Care Prior to Incident",
    fields: [
      {
        fieldNames: "*",
        sourceTab: "Statements",
        sourceSection: "Care or Observation Prior to Incident",
        subSection: "Default",
      },
    ],
  },
  {
    sectionLabel: "Details",
    fields: [
      {
        fieldNames: "*",
        sourceTab: "Details",
        sourceSection: "External Factors",
        subSection: "External Factors",
      },
      {
        fieldNames: "*",
        sourceTab: "Factors",
        sourceSection: "Interventions in place at time of incident",
        subSection: "Preventative Measures",
      },
      {
        fieldNames: "*",
        sourceTab: "Factors",
        sourceSection: "Investigation",
        subSection: "Contributing Factors",
      },
    ],
  },
  {
    sectionLabel: "Response",
    fields: [
      {
        fieldNames: "*",
        sourceTab: "Response",
        sourceSection: "Documentation / Assessments",
        subSection: "Documentation and assessments",
      },
      {
        fieldNames: "*",
        sourceTab: "Response",
        sourceSection: "Interventions",
        subSection: "Interventions",
      },
    ],
  },
  {
    sectionLabel: "Conclusion",
    fields: [
      {
        fieldNames: "*",
        sourceTab: "Conclusion",
        sourceSection: "Root Cause Analysis",
        subSection: "Root Cause Analysis",
      },
      {
        fieldNames: "*",
        sourceTab: "Conclusion",
        sourceSection: "Notifications",
        subSection: "Notifications",
      },
      {
        fieldNames: "*",
        sourceTab: "Conclusion",
        sourceSection: "Conclusion",
        subSection: "Conclusion",
      },
    ],
  },
];

export const formatForRLsInReport = {
  injuries: {
    fieldNames: [
      {
        fieldLabel: "Date/Time Injury reported",
        fieldValue: "Injury_Reported_Date_Time__c",
      },
      { fieldLabel: "Type", fieldValue: "Injury_Type__c" },
      {
        fieldLabel: "Location",
        fieldValue: ["Area__c", "Location__c", "Side__c"],
      },
      { fieldLabel: "Description", fieldValue: "Description__c" },
    ],
    renderFormat: [
      "Injury_Reported_Date_Time__c",
      "Injury_Type__c",
      "$<Area__c> $<Location__c> $<Side__c>",
      "Description__c",
    ],
  },
  interviews: {
    fieldNames: [
      {
        fieldLabel: "Interviewer Name",
        fieldValue: [
          "Interviewer_Role__c",
          "Interviewer_s_Name__c",
          "Interviewer_s_Name_Not_Listed__c",
          "Interviewer_s_Name_Text__c",
          "Interviewer_Name_Text__c",
        ],
      },
      {
        fieldLabel: "Interviewee Name",
        fieldValue: [
          "Interviewee_Role__c",
          "Interviewee_s_Name__c",
          "Interviewee_s_Name_Not_Listed__c",
          "Interviewee_s_Name_Text__c",
          "Interviewee_Name_Text__c",
        ],
      },
      {
        fieldLabel: "Date/Time of Interview",
        fieldValue: "Interview_Date_Time__c",
      },
      {
        fieldLabel: "Interviewee Statement",
        fieldValue: "Interviewee_Statement__c",
      },
    ],
    renderFormat: [
      "$<Interviewer_s_Name__c, Interviewer_s_Name_Text__c, Interviewer_Name_Text__c> ($<Interviewer_Role__c>)",
      "$<Interviewee_s_Name__c, Interviewee_s_Name_Text__c, Interviewee_Name_Text__c> ($<Interviewee_Role__c>)",
      "Interview_Date_Time__c",
      "Interviewee_Statement__c",
    ],
  },
  medications: {
    renderAsString: true,
    renderFormat: "$<Name__c> ($<Dose__c> / $<Frequency__c>)",
    fieldNames: [
      { fieldLabel: "Name", fieldValue: "Name__c" },
      { fieldLabel: "Dose", fieldValue: "Dose__c" },
      { fieldLabel: "Frequency", fieldValue: "Frequency__c" },
    ],
  },
  perpetrators: {
    renderAsString: true,
    renderFormat:
      "$<Staff_s_Name__c, Staff_Name_Text__c, Resident_Name__c, Resident_Name_Text__c, Family_or_Others__c> ($<Role__c>)",
    fieldNames: [
      {
        fieldLabel: "Name",
        fieldValue: [
          "Staff_s_Name__c",
          "Staff_Name_Not_Listed__c",
          "Staff_Name_Text__c",
          "Resident_Name__c",
          "Resident_Name_Not_Listed__c",
          "Resident_Name_Text__c",
          "Family_or_Others__c",
        ],
      },
      { fieldLabel: "Role", fieldValue: "Role__c" },
    ],
  },
  skinIssues: {
    renderAsString: true,
    renderFormat: "$<Area__c> - $<Location__c> $<Side__c>",
    fieldNames: [
      { fieldLabel: "Area", fieldValue: "Area__c" },
      { fieldLabel: "Location", fieldValue: "Location__c" },
      { fieldLabel: "Side", fieldValue: "Side__c" },
    ],
  },
};
